var modules_c052660e = {"container":"_dgugo6","dropdown":"_12xckmd","trigger-element":"_u2gwym","disabled":"_nlwlrv","menu":"_72cwas"};
import "../../../assets/Do1kUmBC.css";

export { modules_c052660e as default };
//# sourceMappingURL=Dropdown.module.less.js.map
